// extracted by mini-css-extract-plugin
export default {"container":"BoxWithHeader_container__+KLQ4","header":"BoxWithHeader_header__gQXxc","dark":"BoxWithHeader_dark__gcXSR","content":"BoxWithHeader_content__ZKJNZ"};